"use client";

import { NewsletterYellow } from "@/stories/Newsletter.stories";
import Newsletter from "../Cards/Newsletter";
import { CardIconColor, TextCardSm } from "@/stories/Card.stories";
import Card from "../Cards/Card";
import Triangles from "../Triangles";
import Text from "../Text/Text";
import { TestimonialBlue } from "@/stories/Testemonial.stories";
import PlayerInPage from "../Player/PlayerInPage";
import Testimonial from "../Text/Testimonial";
import { sendGTMEvent } from "../Analytics";

const iconCardsColor = [
    {
        title: "Meine Faszination wächst unaufhörlich",
        text: "Meine grösste Leidenschaft gehörte schon immer der Erforschung von Energiefeldern und ihren Mechanismen zur Wiederherstellung der natürlichen Funktionsfähigkeit. Sie führt dazu, dass die eigene Kraft nachhaltig aufgebaut werden kann. ",
        img: "/images/colorCard1.png",
        backgroundColor: "bg-yellow",
    },
    {
        title: "Logisch, auch ich will stark sein!",
        text: "Ich habe in meinem Leben kontinuierlich geforscht, während meiner Arbeit und in meiner Freizeit. Dabei stand für mich immer im Mittelpunkt, dass ich eine Arbeitsweise entwickeln kann, die weder mich Energie kostet, noch das Gegenüber beeinträchtigt.",
        img: "/images/colorCard2.png",
        backgroundColor: "bg-blue",
    },
    {
        title: "Gabe alleine reicht nicht aus",
        text: "Meine angeborene Fähigkeit zur präzisen Wahrnehmung ist der Grundstein meiner Arbeit. Ich brenne dafür, die Menschen in ihrem Innersten zu stärken. Um das zu erreichen, habe ich jahrelang hart gearbeitet und mich intensiv mit der Entwicklung meiner Arbeitsweise beschäftigt.",
        img: "/images/colorCard3.png",
        backgroundColor: "bg-pink",
    },
];
export default function UberMichLayout() {
    return (
        <>
            <div className="bg-white flex justify-center">
                <div className="container w-full space-y-1 px-6  py-24  flex-col  gap-5 inline-flex">
                    <div className="flex lg:justify-start lg:items-start justify-center md:w-full lg:w-2/3">
                        <div className="text-black text-[40px] lg:text-[80px]  text-left font-bold   leading-[52px] lg:leading-[80px] ">
                            Schon früh merkte ich, dass ich anders bin
                        </div>
                    </div>

                    <div className="lg:flex md:flex lg:flex-row md:flex-row flex-col lg:space-x-10">
                        <div className="flex justify-center -pt-64">
                            <PlayerInPage
                                videoId="fcde7565e695770137968ff4468ca060"
                                thumbnail="/images/thumbnails/uberMichThumbnail.jpg"
                            />
                        </div>
                        <div>
                            <Text
                                leading="lg:leading-14 leading-10"
                                title="Ich sehe, was viele andere nicht sehen und verstehen können"
                                paragraphs={[
                                    "Meine Forschungsfrage, warum es einigen Menschen gut geht und anderen nicht, beschäftigt mich seit meiner Kindheit. Ausgestattet mit einem fotographischen Gedächtnis und einer starken, schnellen Wahrnehmung, ging ich der Sache auf den Grund. Heute bin ich froh, dass ich Antworten auf diese Frage gefunden habe und sie erfolgreich in die Praxis umsetze. ",
                                    "Dank meiner Fähigkeit kann ich direkt an den Ursachen deiner Blockaden arbeiten. Mit meinem Wissen über das menschliche Energiefeld weiss ich genau, was ich reparieren muss, um dich von innen heraus zu stärken.",
                                    "Ich lese in einem Energiefeld, wie andere in einem Buch. Aus deinem Energiefeld kann ich sofort erkennen, warum es dir nicht gut geht. Ich weiss, was zu tun ist, damit die innere Stärke und Unabhängigkeit wieder wächst. Ich verfüge über eine angeborene, sekundenschnelle Gabe, durch die ich Energiefelder und Zusammenhänge in kürzester Zeit präzise erkennen und die nötige Reparatur daraus ableiten kann.",
                                ]}
                                paddings=""
                                textSize=" text-xl lg:text-xl"
                                titleSize="text-xl3 lg:text-5xl text-left"
                                hasReadMore={true}
                                paragraphSlice={2}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-blue" buttomToTop={false} />
            </div>
            <div className="bg-blue flex justify-center">
                <div className="container w-full space-y-1 px-3  flex-col justify-center items-center gap-5 inline-flex">
                    <Testimonial
                        backgroundColor={TestimonialBlue.args?.backgroundColor}
                        hasDescription={TestimonialBlue.args?.hasDescription}
                        description={"Praxiserfahren seit über 25 Jahren"}
                        name="Rico Brunner"
                        differentTextColor="text-lightYellow"
                        hasImage={TestimonialBlue.args?.hasImage}
                        text="Energiefeldarbeit darf kein Zufall sein. Ich wollte verstehen, warum etwas funktioniert, damit ich es gezielt wiederholen kann. "
                        wordsInDifferentColor={[
                            "kein",
                            "Zufall",
                            "gezielt",
                            "wiederholen",
                        ]}
                        icon={TestimonialBlue.args?.icon}
                    />
                </div>
            </div>
            <div className="bg-blue">
                <Triangles backgroundColor="bg-black" buttomToTop={true} />
            </div>
            <div className="bg-black flex justify-center">
                <div className="container w-full space-y-1 px-6 lg:px-12 flex-col justify-center items-center gap-5 inline-flex">
                    <Text
                        hasPretitle={true}
                        hasText={true}
                        pretitle="Jeder von uns hat genügend Energie"
                        title="Fremdenergie? "
                        subTitle="Für mich ein No-Go!"
                        paragraphs={[
                            "Ich habe in 25 Jahren weltweit mehr als 8’000 Menschen betreut und 40’000 Einzelsitzungen sowie Fernbehandlungen durchgeführt.",
                            "Ich habe ein tiefes Verständnis für die Wechselwirkung zwischen Energiefeldern und Symptomen entwickelt und verwende bei meiner Fernbehandlung keine Fremdenergie. Fremdenergie verursacht Fehlinterpretationen im Energiefeld und beeinträchtigt dadurch die Selbstheilung.",
                            "Meine Forschung und Entwicklung haben mir ein fundiertes Wissen vermittelt, das mir ermöglicht, auf höchstem Niveau zu arbeiten und die seelische Stärke der Menschen nachhaltig zu fördern.",
                        ]}
                        textColor="text-white"
                        hasSubTitle={true}
                        subTitleSize="text-xl3 lg:text-6xl"
                        pretitleSize="lg:text-xl1 text-lg"
                        leadingText="leading-7 lg:leading-8.5"
                    />
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
            <div className="bg-white w-full space-y-1 px-3 lg:px-20 pt-20 pb-10 flex-col justify-center items-center gap-5 inline-flex">
                <div className="text-center text-black text-5xl font-bold  leading-14">
                    Dazu stehe ich
                </div>
                <div className="lg:grid grid-cols-3 md:gap-3 gap-6 text-center lg:space-y-0  space-y-5">
                    {iconCardsColor.map((iconCard) => (
                        <Card
                            key={iconCard.title}
                            width={CardIconColor.args?.width}
                            height={CardIconColor.args?.height}
                            backgroundColor={iconCard.backgroundColor}
                            imageSize={CardIconColor.args?.imageSize}
                            imgSrc={iconCard.img}
                            title={iconCard.title}
                            content={iconCard.text}
                            hasButton={false}
                            buttonPlacement="justify-center"
                        />
                    ))}
                </div>
            </div>
            <div className="bg-background7  bg-cover bg-no-repeat w-full h-full px-3 lg:px-36  py-40 flex-col justify-end  inline-flex">
                <div className="lg:flex md:flex justify-end py-40">
                    <Card
                        width={"lg:w-[700px] md:w-[400px]"}
                        backgroundColor={TextCardSm.args?.backgroundColor}
                        title={TextCardSm.args?.title}
                        content={TextCardSm.args?.content}
                        border={TextCardSm.args?.border}
                        buttonPlacement={TextCardSm.args?.buttonPlacement}
                        contentSize={TextCardSm.args?.contentSize}
                        hasImage={TextCardSm.args?.hasImage}
                        height="lg:h-[300px] h-[400px] md:h-[400px]"
                        titleSize={TextCardSm.args?.titleSize}
                        leadings="leading-10"
                        hasButton={false}
                    />
                </div>
            </div>
            <div className="bg-yellow w-full  px-3 lg:px-20 flex-col justify-center items-center gap-6 inline-flex">
                <Newsletter
                    backgroundColor={NewsletterYellow.args?.backgroundColor}
                    title="Willst du mehr erfahren?"
                    description="Ich lade dich herzlich zu meiner Videosammlung Masterclass ein. Hier dreht sich alles um das faszinierende Thema Energiefelder. Es ist mir wichtig, dass jeder die Möglichkeit hat, von diesem Wissen zu profitieren."
                    buttonText="HOL DIR DIE  MASTERCLASS"
                    hasCheckbox={NewsletterYellow.args?.hasCheckbox}
                    hasDescription={NewsletterYellow.args?.hasDescription}
                    hasInput={NewsletterYellow.args?.hasInput}
                    buttonAs="a"
                    href="/de/masterclass#masterclassSection"
                    hasSubText={NewsletterYellow.args?.hasSubText}
                    buttonPaddings="py-3 px-5 lg:px-10"
                    onClickButton={() => {
                        sendGTMEvent({
                            event: "cta_click",
                            section_title: "Willst du mehr erfahren?",
                            section_index: "7",
                            cta_text: "HOL DIR DIE  MASTERCLASS",
                            cta_link: `${process.env.NEXT_PUBLIC_URL}/de/masterclass#masterclassSection`,
                        });
                    }}
                />
            </div>

            <div className="bg-yellow">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={true} />
            </div>
        </>
    );
}
